<div class="testimonial-container">

  <div class="testimonialHeadingWrapper">
    <h1 class="testimonialHeading">Testimonials</h1>
  </div>

  <div>

    <div #testimonialCard [style.height.px]="calculateCardHeight()" *ngIf="testimonials![selectedIndex]"
    class="testimonial-card" (mouseover)="pauseTestimonials()" (mouseleave)="resetTimer()">

      <div #testimonialData class="testimonial-data">

        <div [ngClass]="{'fade': changing}" class="testimonial-review">
          <span class="quotes">&#8220;</span>{{ testimonials![selectedIndex].review }}<span
            class="quotes">&#8221;</span>
        </div>

        <br />

        <div [ngClass]="{'fade': changing}" class="testimonial-person">&nbsp;{{
          testimonials![selectedIndex].googleUsername }}</div>

        <div [ngClass]="{'fade': changing}" class="testimonial-date">&nbsp;{{ testimonials![selectedIndex].date | date :
          'MMMM yyyy'}}</div>

      </div>
    </div>


  </div>

  <div *ngIf="indicators" class="carousel-dot-container">
    <span *ngFor="let dot of testimonials; let i = index" class="dot" [ngClass]="{'active': selectedIndex === i }"
      (click)="selectTestimonial(i)"></span>
  </div>

  <div *ngIf="controls" class="btn-carousel icon-prev" (click)="onPrevClick()">
    <mat-icon class="icon-carousel">keyboard_arrow_left</mat-icon>
  </div>

  <div *ngIf="controls" class="btn-carousel icon-next" (click)="onNextClick()">
    <mat-icon class="icon-carousel">keyboard_arrow_right</mat-icon>
  </div>


</div>